/**
 * jQuery serializeObject
 * @copyright 2014, macek <paulmacek@gmail.com>
 * @link https://github.com/macek/jquery-serialize-object
 * @license BSD
 * @version 2.5.0
 */
!(function (e, i) {
  if ("function" == typeof define && define.amd)
    define(["exports", "jquery"], function (e, r) {
      return i(e, r);
    });
  else if ("undefined" != typeof exports) {
    var r = require("jquery");
    i(exports, r);
  } else i(e, e.jQuery || e.Zepto || e.ender || e.$);
})(this, function (e, i) {
  function r(e, r) {
    function n(e, i, r) {
      return (e[i] = r), e;
    }
    function a(e, i) {
      for (var r, a = e.match(t.key); void 0 !== (r = a.pop()); )
        if (t.push.test(r)) {
          var u = s(e.replace(/\[\]$/, ""));
          i = n([], u, i);
        } else
          t.fixed.test(r)
            ? (i = n([], r, i))
            : t.named.test(r) && (i = n({}, r, i));
      return i;
    }
    function s(e) {
      return void 0 === h[e] && (h[e] = 0), h[e]++;
    }
    function u(e) {
      switch (i('[name="' + e.name + '"]', r).attr("type")) {
        case "checkbox":
          return "on" === e.value ? !0 : e.value;
        default:
          return e.value;
      }
    }

    function f(i) {
      if (!t.validate.test(i.name)) return this;
      var r = a(i.name, u(i));
      return (l = e.extend(!0, l, r)), this;
    }
    function d(i) {
      if (!e.isArray(i))
        throw new Error("formSerializer.addPairs expects an Array");
      for (var r = 0, t = i.length; t > r; r++) this.addPair(i[r]);
      return this;
    }
    function o() {
      return l;
    }
    function c() {
      return JSON.stringify(o());
    }
    var l = {},
      h = {};
    (this.addPair = f),
      (this.addPairs = d),
      (this.serialize = o),
      (this.serializeJSON = c);
  }
  var t = {
    validate: /^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,
    key: /[a-z0-9_]+|(?=\[\])/gi,
    push: /^$/,
    fixed: /^\d+$/,
    named: /^[a-z0-9_]+$/i,
  };
  return (
    (r.patterns = t),
    (r.serializeObject = function () {
      return new r(i, this).addPairs(this.serializeArray()).serialize();
    }),
    (r.serializeJSON = function () {
      return new r(i, this).addPairs(this.serializeArray()).serializeJSON();
    }),
    "undefined" != typeof i.fn &&
      ((i.fn.serializeObject = r.serializeObject),
      (i.fn.serializeJSON = r.serializeJSON)),
    (e.FormSerializer = r),
    r
  );
});

// End serialize object

var $trialform = $("#free-trial-form"),
  formurl =
    "https://script.google.com/macros/s/AKfycbxvYL5EKtLrjaCjH26TsjTNIGAj-kd3VeNqxq5pphs5cpimmME/exec";

(function ($) {
  $("#free-trial-form").on("submit", function (e) {
    e.preventDefault();

    var $this = $(this);
    var formData = [];
    // Declare email field
    var $formEmail = $this.find('input[name="email"]');

    var $emailVal = $this.find('input[name="email"]').val();

    $(".userEmail").html($emailVal);

    var fullName =
      $this.find('input[name="first_name"]').val().trim() +
      " " +
      $this.find('input[name="last_name"]').val().trim();
    var $formSubmit = $this.find(".btn");

    // Get value of each field in form
    $this.each(function () {
      // Push each field value into formData array
      formData.push($(this).serializeArray());
    });

    // reset any errors
    $("#free-trial-error").text("");
    $formEmail.closest("div").find("label").removeClass("text-danger");
    $formEmail.removeClass("is-invalid");

    toggleEmailInputError(false, $formEmail);

    $("#free-trial-email-warning").text(" ");

    createFreeTrial(formData[0], $formEmail, fullName, $formSubmit);
  });

  function toggleForm() {
    $("#free-trial-form-loading-bar").toggleClass("hide");
    $("#free-trial-form-header").toggleClass("hide");
    $("#free-trial-form-header-thanks").toggleClass("hide");
    $("#free-trial-form-thanks").toggleClass("hide");
    $("section.active > .container").css("height", "auto");
    window.dataLayer.push({
      event: "freeTrialSubmission",
    });
  }

  function createFreeTrial(form, $formEmail, fullName, $formSubmitButton) {
    form["name"] = fullName;
    $formSubmitButton.text("Loading...").addClass("disabled");
    var currentdate = new Date();
    var datetime =
      currentdate.getMonth() +
      1 +
      "/" +
      currentdate.getDate() +
      "/" +
      currentdate.getFullYear() +
      " at " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    $("#free-trial-form .formdate").val(datetime);
    console.log(datetime);
    $.ajax({
      url: "/wp-content/themes/konghq/inc/initialize-free-trial.php",
      method: "POST",
      data: form,
      dataType: "json",
      success: function (res) {
        if (res.type === "email" && res.status === "invalid") {
          $("#free-trial-form .formerror").val(
            "Invalid email address/non-work email"
          );
          var jqxhr = $.ajax({
            url: formurl,
            method: "GET",
            dataType: "json",
            data: $trialform.serializeObject(),
          }).success();
          $formSubmitButton.text("Get Started").removeClass("disabled");
          $("#free-trial-form-wrapper, .cloud-form .confirmation").toggleClass(
            "hide"
          );
          $("#free-trial-form-loading-bar").toggleClass("hide");
          sendEmailFailure();
          return;
        }
        if (res.status == "valid") {
          dataLayer.push({
            event: "wpcf7successfulsubmit",
            CF7formID: 'Free Trial',
          });
          $("#free-trial-form .formerror").val("No error");
          var jqxhr = $.ajax({
            url: formurl,
            method: "GET",
            dataType: "json",
            data: $trialform.serializeObject(),
          }).success();
          $(".progress").css("-webkit-animation-duration", "8s");
          setTimeout(function () {
            toggleForm();
          }, 700);
        } else {
          $("#free-trial-form .formerror").val(res.errorMessage);
          var jqxhr = $.ajax({
            url: formurl,
            method: "GET",
            dataType: "json",
            data: $trialform.serializeObject(),
          }).success();
          $("#free-trial-form-loading-bar").toggleClass("hide");
          $("#free-trial-form-wrapper-error").toggleClass("hide");
        }
      },
      error: function (error) {
        console.log(error);
        var data = error.responseText;
        console.log(data);
        if (data.type === "email") {
          $formSubmitButton.text("Get Started").removeClass("disabled");
          $("#free-trial-form-wrapper").toggleClass("hide");
          $("#free-trial-form-loading-bar").toggleClass("hide");
          //sendEmailFailure()
          return;
        }

        // If Error display error message
        $("#free-trial-form-loading-bar").toggleClass("hide");
        $("#free-trial-form-wrapper-error").toggleClass("hide");
      },
    });

    $("#free-trial-form-wrapper, .cloud-form .confirmation").toggleClass(
      "hide"
    );
    $("#free-trial-form-loading-bar").toggleClass("hide");

    function sendEmailFailure() {
      toggleEmailInputError(true, $formEmail);
      $("#free-trial-email-warning").text(
        "Please use your work email address."
      );
    }
  }

  function toggleEmailInputError(hasError, $formEmail) {
    if (hasError) {
      $formEmail.closest("div").find("label").addClass("text-danger");
      $formEmail.addClass("is-invalid");
    } else {
      $formEmail.closest("div").find("label").removeClass("text-danger");
      $formEmail.removeClass("is-invalid");
    }
  }
})(jQuery);

var $form = $("#free-cloud-trial-form"),
  url =
    "https://script.google.com/macros/s/AKfycbzq9Tr4zQLtl7DWaqKW8zeNc_Ei8WA3Nq7CTH-DgPRX6HDOonw/exec";

(function ($) {
  $("#free-cloud-trial-form").on("submit", function (e) {
    var pardotQuery = jQuery("#free-cloud-trial-form").serialize();
    e.preventDefault();
    var $this = $(this);
    var formData = [];
    // Declare email field
    var $formEmail = $this.find('input[name="email"]');
    // Add email to the confirmation message
    var $emailVal = $this.find('input[name="email"]').val();

    $(".userEmail").html($emailVal);
    var fullName =
      $this.find('input[name="first_name"]').val().trim() +
      " " +
      $this.find('input[name="last_name"]').val().trim();
    var $formSubmit = $this.find(".btn");

    // Get value of each field in form
    $this.each(function () {
      // Push each field value into formData array
      formData.push($(this).serializeArray());
    });

    // reset any errors
    $("#free-trial-error").text("");
    $formEmail.closest("div").find("label").removeClass("text-danger");
    $formEmail.removeClass("is-invalid");
    toggleCloudEmailInputError(false, $formEmail);

    $("#free-trial-email-warning").text(" ");

    createFreeCloudTrial(
      formData[0],
      $formEmail,
      fullName,
      pardotQuery,
      $formSubmit
    );
  });

  function toggleCloudForm() {
    $("#free-trial-form-loading-bar").toggleClass("hide");
    $("#free-trial-form-header").toggleClass("hide");
    $("#free-trial-form-header-thanks").toggleClass("hide");
    $("#free-trial-form-thanks").toggleClass("hide");
    $("section.active > .container").css("height", "auto");
    window.dataLayer.push({
      event: "freeTrialSubmission",
    });
  }

  function createFreeCloudTrial(
    form,
    $formEmail,
    fullName,
    pardotQuery,
    $formSubmitButton
  ) {
    form["name"] = fullName;

    $formSubmitButton.text("Loading...").addClass("disabled");
    var currentdate = new Date();
    var datetime =
      currentdate.getMonth() +
      1 +
      "/" +
      currentdate.getDate() +
      "/" +
      currentdate.getFullYear() +
      " at " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    $("#free-cloud-trial-form .formdate").val(datetime);
    console.log(datetime);
    $.ajax({
      url: "/wp-content/themes/konghq/inc/initialize-free-cloud-trial.php",
      method: "POST",
      data: form,
      dataType: "json",
      success: function (res) {
        if (res.type === "email" && res.status === "invalid") {
          $("#free-cloud-trial-form .formerror").val(
            "Invalid email address/non-work email"
          );
          var jqxhr = $.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            data: $form.serializeObject(),
          }).success();
          $formSubmitButton.text("Get Started").removeClass("disabled");
          $("#free-trial-form-wrapper, .cloud-form .confirmation").toggleClass(
            "hide"
          );
          $("#free-trial-form-loading-bar").toggleClass("hide");
          sendCloudEmailFailure();
          return;
        }
        if (res.status == "valid") {
          dataLayer.push({
            event: "wpcf7successfulsubmit",
            CF7formID: 'Free Trial',
          });
          $("#free-cloud-trial-form .formerror").val("No error");
          var jqxhr = $.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            data: $form.serializeObject(),
          }).success();
          console.log("here is the pardot query" + pardotQuery);
          jQuery.ajax({
            url: "https://go.konghq.com/l/392112/2020-06-17/bmhyzd",
            type: "POST",
            dataType: "jsonp",
            crossDomain: true,
            async: false,
            data: pardotQuery,
            xhrFields: {
              withCredentials: true,
            },
            success: function () {
              console.log("callback: success");
            },
          });
          $(".progress").css("-webkit-animation-duration", "8s");

          setTimeout(function () {
            toggleCloudForm();
          }, 700);
        } else {
          $("#free-cloud-trial-form .formerror").val(res.errorMessage);
          var jqxhr = $.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            data: $form.serializeObject(),
          }).success();
          $("#free-trial-form-loading-bar").toggleClass("hide");
          $("#free-trial-form-wrapper-error").toggleClass("hide");
        }
      },
      error: function (error) {
        console.log(error);
        var data = error.responseText;
        console.log(data);
        if (data.type === "email") {
          $formSubmitButton.text("Get Started").removeClass("disabled");
          $("#free-trial-form-wrapper").toggleClass("hide");
          $("#free-trial-form-loading-bar").toggleClass("hide");
          //sendCloudEmailFailure()
          return;
        }

        // If Error display error message
        $("#free-trial-form-loading-bar").toggleClass("hide");
        $("#free-trial-form-wrapper-error").toggleClass("hide");
      },
    });

    $("#free-trial-form-wrapper").toggleClass("hide");
    $("#free-trial-form-loading-bar").toggleClass("hide");

    function sendCloudEmailFailure() {
      toggleCloudEmailInputError(true, $formEmail);
      $("#free-trial-email-warning").text(
        "Please use your work email address."
      );
    }
  }

  function toggleCloudEmailInputError(hasError, $formEmail) {
    if (hasError) {
      $formEmail.closest("div").find("label").addClass("text-danger");
      $formEmail.addClass("is-invalid");
    } else {
      $formEmail.closest("div").find("label").removeClass("text-danger");
      $formEmail.removeClass("is-invalid");
    }
  }
})(jQuery);
